/**
 * @generated SignedSource<<115a6d06959fb32a4d42abef006a8744>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ArchiveArchivableInput = {
  clientMutationId?: string | null;
  archivableId: string;
};
export type PopupBulkArchiveModalContainer_Mutation$variables = {
  input: ArchiveArchivableInput;
  connections: ReadonlyArray<string>;
};
export type PopupBulkArchiveModalContainer_MutationVariables = PopupBulkArchiveModalContainer_Mutation$variables;
export type PopupBulkArchiveModalContainer_Mutation$data = {
  readonly archiveArchivable: {
    readonly archivable: {
      readonly id: string;
      readonly isArchive: boolean;
    };
  } | null;
};
export type PopupBulkArchiveModalContainer_MutationResponse = PopupBulkArchiveModalContainer_Mutation$data;
export type PopupBulkArchiveModalContainer_Mutation = {
  variables: PopupBulkArchiveModalContainer_MutationVariables;
  response: PopupBulkArchiveModalContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchive",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupBulkArchiveModalContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ArchiveArchivablePayload",
        "kind": "LinkedField",
        "name": "archiveArchivable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "archivable",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PopupBulkArchiveModalContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ArchiveArchivablePayload",
        "kind": "LinkedField",
        "name": "archiveArchivable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "archivable",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cc1ab5fecae8312f4b7f72e9f7c6d2aa",
    "id": null,
    "metadata": {},
    "name": "PopupBulkArchiveModalContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation PopupBulkArchiveModalContainer_Mutation(\n  $input: ArchiveArchivableInput!\n) {\n  archiveArchivable(input: $input) {\n    archivable {\n      __typename\n      id\n      isArchive\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9afbd3e5656fe63709696faf05f292de";

export default node;
